import styled, { useTheme } from 'styled-components';

import { min } from '../utils/breakpoints';

import { default as LoopSpinnerSvg } from './Icon/LoopSpinner';

const StyledImg = styled.div`
  animation: spin 1s linear infinite;
  width: 50px;
  height: 50px;
  justify-content: center;
  align-items: center;
  align-self: center;
  justify-self: center;

  svg: {
    width: 50px;
    height: 50px;
  }

  ${min.sm} {
    width: 80px;
    height: 80px;

    svg: {
      width: 80px;
      height: 80px;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoopSpinner = () => {
  const theme = useTheme();
  return (
    <div className="text-center">
      <StyledImg>
        <LoopSpinnerSvg backgroundColor={theme.colors.primary} />
      </StyledImg>
    </div>
  );
};

export default LoopSpinner;
